const PrivacyPolicyAction = {
    GET_PRIVACY_POLICY: "GET_PRIVACY_POLICY",
    GET_PRIVACY_POLICY_LOADING: "GET_PRIVACY_POLICY_LOADING",
    GET_PRIVACY_POLICY_FAILED: "GET_PRIVACY_POLICY_FAILED",
    GET_PRIVACY_POLICY_SUCCESS: "GET_PRIVACY_POLICY_SUCCESS",
}

export default PrivacyPolicyAction;